import { render, staticRenderFns } from "./RiskFilter.vue?vue&type=template&id=0b7f8ffd&"
import script from "./RiskFilter.vue?vue&type=script&lang=js&"
export * from "./RiskFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports